import { ConfigProps } from '@config/types'

const config = ({ deploymentEnv }: ConfigProps) =>
  ({
    scriptUrl: `${deploymentEnv === 'prod' ? 'https://www.blick.ch' : 'https://cdn.cookielaw.org'}/scripttemplates/otSDKStub.js`,
    scriptDomain: 'd57e5842-f42f-46bc-a4ea-4a82bd82322c',
  }) as const satisfies Record<string, unknown>

export default config
